<div class="container-fluid mt-4">
  <!-- Main Card Container -->
  <div class="card attendance-dashboard-card">
    <!-- Card Header with Title and Filters -->
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <div class="header-title">
            <h2 class="mb-0">Employee Attendance</h2>
            <p class="subtitle mb-0">
              Track and manage employee attendance records
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <!-- Filter Controls -->
          <form [formGroup]="filterForm">
            <div class="row">
              <div class="col-12 col-md-3">
                <label>Month</label>
                <p-calendar
                  formControlName="month"
                  view="month"
                  dateFormat="mm/yy"
                  [readonlyInput]="true"
                  (onSelect)="onDateChange($event)"
                ></p-calendar>
              </div>
              <div
                class="col-12 col-md-3"
                *ngIf="!isFactoryManager && !isSupervisor"
              >
               <label>Department</label>
                <ng-select
                  class="form-class"
                  [items]="departmentDropdown"
                  bindLabel="department_name"
                  placeholder="Select Department"
                  name="department_name"
                  id="department_name"
                  formControlName="selectedDepartment"
                  (change)="onDepartmentChange($event)"
                  bindValue="department_name"
                ></ng-select>
              </div>
              <div class="col-12 col-md-3" *ngIf="!isSupervisor">
                   <label>Employee</label>
                <ng-select
                  class="form-class"
                  [items]="employeeDropdown"
                  bindLabel="employee_name"
                  name="employee_name"
                  id="employee_name"
                  formControlName="selectedEmployee"
                  (change)="onEmployeeChange($event)"
                  bindValue="employee_id"
                ></ng-select>
              </div>
              <div class="col-12 col-md-3">
                <button
                  class="filterApply me-2"
                  (click)="exportExcel(groupedEmployee)"
                >
                  <i class="fas fa-download me-2"></i>
                    Export
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Card Body with Attendance Data -->
    <div *ngIf="isLoading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading dashboard data...</p>
    </div>
    <div class="card-body" *ngIf="!isLoading">
      <!-- Summary Stats -->
      <div class="summary-stats mb-4">
        <div class="row">
          <div class="col-md-3">
            <div class="stat-card">
              <div class="stat-value">{{ attendancePercentage }}%</div>
              <div class="stat-label">Overall Attendance</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-success"
                  [style.width.%]="attendancePercentage"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card">
              <div class="stat-value">{{ absentPercentage }}%</div>
              <div class="stat-label">Absent Rate</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-danger"
                  [style.width.%]="absentPercentage"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card">
              <div class="stat-value">{{ fullDayCount }} Days</div>
              <div class="stat-label">Present days</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-secondary"
                  [style.width.%]="fullDayCount"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card">
              <div class="stat-value">{{ absentCount }} Days</div>
              <div class="stat-label">Absent Days</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-warning"
                  [style.width.%]="absentCount"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Attendance Table -->
      <div class="table-responsive">
        <table class="table attendance-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Employee Name</th>
              <th>Department</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of groupedEmployee; index as i">
              <td
                routerLink="/admin/employee-attendence-detail"
                [queryParams]="{ id: item.employee_id , date :formattedDate }"
              >
                {{ i + 1 }}
              </td>
              <td
                routerLink="/admin/employee-attendence-detail"
                [queryParams]="{ id: item.employee_id , date :formattedDate }"
              >
                {{ item.employee_name }}
              </td>
              <td
                routerLink="/admin/employee-attendence-detail"
                [queryParams]="{ id: item.employee_id , date :formattedDate }"
              >
                {{ item.department }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <!-- <div class="d-flex justify-content-between align-items-center mt-4">
                <div class="showing-entries">
                    Showing 1 to 5 of 25 entries
                </div>
                <nav>
                    <ul class="pagination">
                        <li class="page-item disabled">
                            <a class="page-link" href="#" tabindex="-1">Previous</a>
                        </li>
                        <li class="page-item active"><a class="page-link" href="#">1</a></li>
                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                        <li class="page-item">
                            <a class="page-link" href="#">Next</a>
                        </li>
                    </ul>
                </nav>
            </div> -->
    </div>
  </div>
</div>

<!-- Edit Attendance Modal -->
<div
  class="modal fade"
  id="editAttendanceModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-calendar-check me-2"></i>
          Edit Attendance Record
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Date</label>
              <input type="date" class="form-control" value="2025-06-02" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Employee</label>
              <input
                type="text"
                class="form-control"
                value="Ali Mohammed"
                readonly
              />
            </div>
            <div class="col-md-3">
              <label class="form-label">Work In</label>
              <input type="time" class="form-control" value="08:10" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Break Out</label>
              <input type="time" class="form-control" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Break In</label>
              <input type="time" class="form-control" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Work Out</label>
              <input type="time" class="form-control" value="19:10" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Status</label>
              <select class="form-select">
                <option>Full Day</option>
                <option>Half Day</option>
                <option selected>Absent</option>
                <option>Leave</option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Leave Type</label>
              <select class="form-select">
                <option selected>None</option>
                <option>Annual Leave (AL)</option>
                <option>Casual Leave (CL)</option>
                <option>Sick Leave (SL)</option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label">Remarks</label>
              <textarea class="form-control" rows="3"></textarea>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
        <button type="button" class="btn btn-primary">Save Changes</button>
      </div>
    </div>
  </div>
</div>
